import React, {useEffect} from "react";
import {Routes, Route} from "react-router-dom";
import FillingType from "../../layout/product/filling/FillingType";
import AddFillingType from "../../layout/product/filling/AddFillingType";
import PriceLayout from "../../layout/product/PriceLayout";

const FillingTypePage = () => {
    useEffect(() => {
        return () => {
            localStorage.removeItem("feselectedId");
            localStorage.removeItem("feitemOffset");
            localStorage.removeItem("feforcePage");
        };
    }, []);
    return (
        <>
            <Routes>
                <Route path="/" element={<FillingType/>}/>
                <Route path="/add" element={<AddFillingType/>}/>
                <Route path="/update/:id" element={<AddFillingType/>}/>
                <Route path="/price/:id/:name" element={<PriceLayout/>}/>
            </Routes>
        </>
    );
};

export default FillingTypePage;
